<script>
export default {
  name: 'TransactionBillingInfo',
  props: {
    maskedBillingAddress: {
      type: Object,
      required: true
    },
    maskedConsumer: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <div
    id="transaction-billing-info"
    class="mb-4 mt-4"
  >
    <h4 class="font-weight-bold mb-4">
      {{ $t ('header.billingInformation') }}
    </h4>
    <div>
      <div
        id="billing-address-full-name"
        data-test="billing-address-full-name"
      >
        {{ (maskedBillingAddress || {}).name || '' }}
      </div>
      <div
        id="billing-address"
        data-test="billing-address"
      >
        <span
          v-if="maskedBillingAddress.line1"
          id="billing-address-line1"
          data-test="billing-address-line1"
        >
          {{ maskedBillingAddress.line1 }}
          <br>
        </span>

        <span
          v-if="maskedBillingAddress.line2"
          id="billing-address-line2"
          data-test="billing-address-line2"
        >
          {{ maskedBillingAddress.line2 }}
          <br>
        </span>
        <span
          v-if="maskedBillingAddress.line3"
          id="billing-address-line3"
          data-test="billing-address-line3"
        >
          {{ maskedBillingAddress.line3 }}
          <br>
        </span>
        <span
          v-if="maskedBillingAddress.city"
          id="billing-address-city"
          data-test="billing-address-city"
        >
          {{ maskedBillingAddress.city }},
        </span>
        <span
          v-if="maskedBillingAddress.state"
          id="billing-address-state"
          data-test="billing-address-state"
        >
          {{ maskedBillingAddress.state }},
        </span>
        {{ maskedBillingAddress.countryCode }} {{ maskedBillingAddress.zip }}
      </div>

      <div
        id="billing-address-phone"
        data-test="billing-address-phone"
      >
        {{ (maskedConsumer.maskedConsumerMobileNumber || {}).phoneNumber }}
      </div>

      <div
        v-if="maskedConsumer.maskedEmailAddress"
        id="billing-address-email"
        data-test="billing-address-email"
      >
        {{ maskedConsumer.maskedEmailAddress }}
      </div>
    </div>
  </div>
</template>
